import { render, staticRenderFns } from "./layout_admin.vue?vue&type=template&id=52a7b8bc&scoped=true&"
import script from "./layout_admin.vue?vue&type=script&lang=js&"
export * from "./layout_admin.vue?vue&type=script&lang=js&"
import style0 from "./layout_admin.vue?vue&type=style&index=0&id=52a7b8bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a7b8bc",
  null
  
)

export default component.exports